export class ReferrerModel {
  constructor() {
    this.name = "";
    this.phone = "";
  }
}
